import { PGridItem, PBanner } from '@porsche-design-system/components-react'
import React from 'react'

import ContentSection from '../../Content/Main/Section/ContentSection'

import styles from './noratingsbanner.module.css'

const NoRatingsBanner = () => {
  return (
    <PGridItem size={12}>
      <ContentSection className={styles.contentBanner}>
        <PBanner width='extended' className={styles.banner} persistent>
          <span slot='title'>Es sind keine Bewertungen vorhanden.</span>
          <span slot='description'>Passen Sie den Zeitraum oder die Auswahl der Applikation an.</span>
        </PBanner>
      </ContentSection>
    </PGridItem>
  )
}

export default NoRatingsBanner
